import { createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, openBlock as _openBlock } from "vue";

export default function render(_ctx, _cache) {
  return (
    _openBlock(),
    _createElementBlock(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
      },
      [
        _createElementVNode("path", {
          fill: "currentColor",
          "fill-rule": "evenodd",
          d: "m18.715 11.286-2.858 2.857H13l-2.5 2.5v-2.5H7.286V3.429h11.429v7.857ZM6.57 2 3 5.571V18.43h4.286V22l3.571-3.571h2.857L20.144 12V2H6.57Zm8.572 8.213h1.428V5.928h-1.428v4.285Zm-2.502 0h-1.428V5.928h1.429v4.285Z",
          "clip-rule": "evenodd",
        }),
      ]
    )
  );
}
